import React, { Component } from "react";
import {
  Col,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { shape, func } from "prop-types";
import { withRouter } from "react-router-dom";
import swal from "sweetalert2";
import LoadingOverlay from "../../Components/LoadingOverlay";
import { Formik } from "formik";
import LimitInput from "../EditLimit/LimitInput";
import limitsApi from "../../../api/limits";
import { handleError } from "@/util/errorHandler";
import { getNewLimitSchema } from "@/util/validationHelper";

const warningStyle = {
  color: "red",
  fontSize: 10,
  height: 25,
  paddingTop: 5,
};

const AccountTypes = {
  MOBILE: "MOBILE",
  DESKTOP: "DESKTOP",
  WEB: "WEB",
};

class AddLimitComponent extends Component {
  static propTypes = {
    history: shape({ goBack: func.isRequired }).isRequired,
  };

  state = {
    isSending: false,
  };

  validationSchema() {
    return getNewLimitSchema();
  }

  onSubmit = async ({
    KHR,
    USD,
    limitName,
    accountType,
    description,
    kycStatus,
  }) => {
    this.setState({ isSending: true });

    try {
      return await limitsApi
        .addLimit({
          limitName,
          limits: {
            "usd#nbc": {
              dayLimit: USD,
            },
            "khr#nbc": {
              dayLimit: KHR,
            },
          },
          accountType,
          description,
          kycStatus,
        })
        .then(() =>
          swal("Success", `${limitName} created successfully`, "success"),
        );
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isSending: false });
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    const { isSending } = this.state;

    return (
      <Formik
        initialValues={{
          KHR: 0,
          USD: 0,
          accountType: AccountTypes.MOBILE,
          limitName: "",
          description: "",
          kycStatus: "FULL_KYC",
        }}
        validationSchema={this.validationSchema()}
        onSubmit={this.onSubmit}
        enableReinitialize>
        {({ values, handleSubmit, handleChange, errors, touched }) => (
          <Form onSubmit={handleSubmit}>
            <Card>
              <LoadingOverlay loading={isSending} />
              <CardHeader>Add limit</CardHeader>
              <CardBody>
                <FormGroup row>
                  <Label sm={2}>Limit name:</Label>
                  <Col sm={10}>
                    <Input
                      type="text"
                      name="limitName"
                      value={values.limitName}
                      onChange={handleChange}
                      invalid={Boolean(errors.limitName)}
                    />
                    <div style={warningStyle} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={2}>Type:</Label>
                  <Col sm={3}>
                    <Input
                      type="select"
                      name="accountType"
                      value={values.accountType}
                      onChange={handleChange}
                      invalid={Boolean(errors.accountType)}>
                      <option value={AccountTypes.MOBILE}>Mobile</option>
                      <option value={AccountTypes.DESKTOP}>Desktop</option>
                      <option value={AccountTypes.WEB}>Web</option>
                    </Input>
                    <div style={warningStyle} />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={2}>KYC Status:</Label>
                  <Col sm={3}>
                    <Input
                      type="select"
                      name="kycStatus"
                      value={values.kycStatus}
                      onChange={handleChange}>
                      <option value="FULL_KYC">FULL_KYC</option>
                      <option value="PARTIAL_KYC">PARTIAL_KYC</option>
                    </Input>
                    <div style={warningStyle} />
                  </Col>
                </FormGroup>
                <div style={{ marginBottom: 30 }}>
                  Please input maximum amount of transactions
                </div>
                <FormGroup row>
                  <Label sm={2}>Amount in KHR:</Label>
                  <Col sm={5}>
                    <LimitInput
                      currency="KHR"
                      value={values.KHR}
                      onChange={handleChange}
                      invalid={Boolean(errors.KHR)}
                    />
                    <div style={warningStyle}>{errors.KHR}</div>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={2}>Amount in USD:</Label>
                  <Col sm={5}>
                    <LimitInput
                      currency="USD"
                      value={values.USD}
                      onChange={handleChange}
                      invalid={Boolean(errors.USD)}
                    />
                    <div style={warningStyle}>{errors.USD}</div>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label sm={2}>Description:</Label>
                  <Col sm={8}>
                    <Input
                      type="textarea"
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                    />
                    <div style={warningStyle} />
                  </Col>
                </FormGroup>
              </CardBody>
              <CardFooter>
                <Button color="success" type="submit" data-cy="submit">
                  Submit
                </Button>
                <Button
                  color="primary"
                  style={{ marginLeft: 20 }}
                  onClick={this.goBack}
                  data-cy="back">
                  <i className="fa fa-arrow-left mr-2 " />
                  Back
                </Button>
              </CardFooter>
            </Card>
          </Form>
        )}
      </Formik>
    );
  }
}

const AddLimit = withRouter(AddLimitComponent);

export { AddLimit };
